"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
var Constants_1 = require("../common/Constants");
var HttpClient_1 = require("../http/HttpClient");
var HttpHeaders_1 = require("../http/HttpHeaders");
var HttpRequestType_1 = require("../http/HttpRequestType");
var RequestHelper_1 = require("../http/RequestHelper");
var Util_1 = require("../common/Util");
var V1PollingHelper = /** @class */ (function () {
    function V1PollingHelper() {
    }
    V1PollingHelper.poll = function (url, registrationToken, callback) {
        var headers = RequestHelper_1.default.getDefaultIC3Headers();
        headers[HttpHeaders_1.default.RegistrationTokenHeader] = registrationToken;
        headers[HttpHeaders_1.default.ContentTypeHeader] = Constants_1.default.ContentTypeJson;
        var payload = JSON.stringify({});
        var requestParameters = {
            callbackOnFailure: callback,
            data: payload,
            enableExponentialBackoff: true,
            headers: headers,
            redirect404RetryCount: Constants_1.default.retryCount,
            retryCount: Constants_1.default.retryCount,
            shouldRedirectOn404: true,
            shouldResetOnFailure: true,
            shouldRetryOnFailure: Util_1.default.shouldRetryOnFailure,
            timeBetweenRetry: Constants_1.default.timeBetweenOperationRetry,
            type: HttpRequestType_1.default.POST,
            url: url
        };
        return HttpClient_1.HttpClient.MakeRequest(requestParameters);
    };
    return V1PollingHelper;
}());
exports.default = V1PollingHelper;
//# sourceMappingURL=V1PollingHelper.js.map